import styled from 'react-emotion'

const Content = styled('div')({
    flex: 1,
    boxSizing: 'border-box',
    padding: '50px 50px 40px',
    background: '#e9ecf0',
    '@media (max-width: 500px)': {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 35,
        paddingBottom: 35
    }
})

export default Content



// WEBPACK FOOTER //
// ./src/components/ContentComponent.jsx